// extracted by mini-css-extract-plugin
export default {"container":"XE-z","innerContainer":"YE-z","multipleLines":"ZE-z","heading":"_E-z","content":"aF-z","linkColor":"bF-z"};